import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Custom__qgiv-bookmark",
  "use": "Custom__qgiv-bookmark-usage",
  "viewBox": "0 0 14 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 14 18\" id=\"Custom__qgiv-bookmark\"><path d=\"M12.31 0H2.177C1.243 0 .486.742.486 1.657v14.909c0 .853.943 1.384 1.694.954l5.063-2.897 5.064 2.897c.75.4 1.693-.101 1.693-.954V1.657C14 .742 13.243 0 12.31 0Zm0 15.603-5.067-2.9-5.067 2.9V1.864c0-.116.092-.207.179-.207h9.713c.151 0 .243.091.243.207v13.739Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol